import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Resize,
} from "@syncfusion/ej2-react-grids";
import {
  GetAllEmployees,
  getPartsListByStoreFilter,
  ImportWbApi,
  ReceiveWbApi,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { useStateContext } from "../../contexts/ContextProvider";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import DateTimeField from "../../components/DateTimeField";

const ImportWb = () => {
  const navigate = useNavigate();
  const { storeG, userID } = useStateContext();
  const [getParts, setParts] = useState([]);
  const [getEmployees, setEmployees] = useState([]);
  const [Sns, setSns] = useState([]);
  const [formData, setFormData] = useState({
    part: "Select Part",
    wb_name: "",
    specs: "",
    detail: "",
    qty: "1",
    employee: "Select Employee",
  });
  const [oDatetime, setODatetime] = useState("");
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const snsGrid = [
    {
      field: "item_no",
      headerText: "SNo",
      minWidth: "40",
      width: "60",
      textAlign: "left",
    },
    {
      field: "prod_date",
      headerText: "Prod Date",
      type: "date",
      format: "dd/MM/yyyy",
      minWidth: "40",
      width: "95",
      textAlign: "left",
    },
    {
      field: "id_no1",
      headerText: "ZOOX ID Number",
      minWidth: "40",
      width: "140",
      textAlign: "left",
    },
    {
      field: "wb_sn",
      headerText: "Serial Number",
      minWidth: "40",
      width: "170",
      textAlign: "left",
    },
    {
      field: "id_no2",
      headerText: "PNY ID Number",
      minWidth: "40",
      width: "180",
      textAlign: "left",
    },
    {
      field: "test",
      headerText: "Test Result",
      minWidth: "40",
      width: "100",
      textAlign: "left",
    },
  ];

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      if (e.name === "part")
        setFormData((prev) => ({
          ...prev,
          [e.name]: option,
          wb_name: option.label,
        }));
      else setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const bufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const chunkSize = 0x8000; // 32KB chunks
    for (let i = 0; i < bytes.length; i += chunkSize) {
      const subarray = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode.apply(null, subarray);
    }
    return btoa(binary);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file || file.name.toLowerCase().endsWith(".xlsx,.xls")) return;

    const maxSize = 1 * 1024 * 1024; // 1 MB in bytes
    if (file.size > maxSize) {
      showErrorToast("Error!", "File exceed the 1MB limit!");
      e.target.value = "";
      return;
    }
    try {
      const buffer = await file.arrayBuffer();
      const base64 = bufferToBase64(buffer);
      var fileData = {
        part_id: 0,
        store_id: storeG.store_id,
        employee_id: 0,
        user_id: userID,
        recv_scan_date: null,
        file_doc: base64,
        note: `${file.name}`,
      };
      const uploadResp = await ImportWbApi(fileData);
      if (!uploadResp.success)
        showErrorToast(
          "Error!",
          "WBs failed to import!\n\n" + uploadResp.message,
        );
      else {
        const ledgs = uploadResp.data.map((item, i) => ({
          item_no: i + 1,
          prod_date: item.prod_date,
          wb_sn: item.sn,
          qrscan: item.qrcode,
          id_no1: item.id_no1,
          id_no2: item.id_no2,
          test: item.test_result,
          other: "",
          note: "",
        }));
        setSns(ledgs || []);
        setFormData((prev) => ({ ...prev, qty: ledgs.length }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    const snItems = Sns.map((item, i) => ({
      name: formData.wb_name,
      specs: formData.specs,
      detail: formData.detail,
      prod_date: item.prod_date || null,
      qrcode: item.qrscan,
      id_no1: item.id_no1,
      id_no2: item.id_no2,
      sn: item.wb_sn,
      test_result: item.test,
      other: item.other,
      notes: item.note,
    }));
    const reqData = {
      part_id: formData.part.value,
      store_id: storeG.store_id,
      employee_id: formData.employee.value,
      user_id: userID,
      recv_scan_date: oDatetime,
      water_blocks: snItems,
    };
    try {
      const response = await ReceiveWbApi(reqData);
      if (response.success) {
        showSuccessToast("Success!", "WBs Received successfully!");
        navigate("/GpuWb");
      } else
        showErrorToast("Error!", "WBs failed to recv!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "WBs did not receive!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        TimeoutUtility.resetTimeout();
        var now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        setODatetime(now.toISOString().slice(0, 19));
        await GetAllEmployees()
          .then((resp) => {
            const employeeOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.employee_id,
            }));
            setEmployees(employeeOptions || []);
          })
          .catch((err) => console.log(err.message));
        await getPartsListByStoreFilter(storeG?.store_id, "water block")
          .then((resp) => {
            const partOptions = resp.data.map((item) => ({
              label: item.part_number + " - " + item.description,
              value: item.part_id,
            }));
            setParts(partOptions || []);
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="IMPORT RECEIVE WATER BLOCKS" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={8} lg={12} className="container-col">
              <SelectField
                label="Part:"
                name="part"
                value={formData.part}
                options={getParts}
                onChange={handleSelectChange}
                placeholder="Part"
                compulsory={true}
                error={errors.part}
              />
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={4} lg={4} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Name:"
                  name="wb_name"
                  value={formData.wb_name}
                  onChange={handleChange}
                  placeholder="Name"
                  error={errors.wb_name}
                />
                <TextInputField
                  label="Specs:"
                  name="specs"
                  value={formData.specs}
                  onChange={handleChange}
                  placeholder="Specs"
                  error={errors.specs}
                />
                <TextAreaField
                  label="Detail:"
                  name="detail"
                  value={formData.detail}
                  onChange={handleChange}
                  placeholder="Detail"
                  error={errors.detail}
                />
                <div style={{ marginTop: "94px" }} />
                <DoubleField
                  label="Recv Qty:"
                  name="qty"
                  value={formData.qty}
                  placeholder="Receive Quantity"
                  disabled
                />
                <SelectField
                  label="Recv Operator:"
                  name="employee"
                  value={formData.employee}
                  options={getEmployees}
                  onChange={handleSelectChange}
                  placeholder="Operator"
                  compulsory={true}
                  error={errors.employee}
                />
                <DateTimeField
                  label="Recv Datetime:"
                  name="recv_date"
                  value={oDatetime}
                  placeholder="DateTime"
                  now={false}
                  formField={true}
                  disabled
                />
              </div>
            </Col>
            <Col xl={8} lg={8} className="container-col">
              <div className="mt-3 mb-3">
                <label className="label mb-1">Import:</label>
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={handleFileChange}
                />
              </div>
              <GridComponent
                className="custom-grid1"
                dataSource={Sns}
                height="calc(56vh - 100px)"
                allowResizing
                //  allowSorting
                //  recordDoubleClick={handleRowDoubled}
                rowHeight={24}
              >
                <ColumnsDirective>
                  {snsGrid.map((item, index) => (
                    <ColumnDirective key={index} {...item} />
                  ))}
                </ColumnsDirective>
                <Inject services={[Resize]} />
              </GridComponent>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Create"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ImportWb;
